import React, { useState } from 'react';
import Button from 'antd/lib/button';
import Modal from 'antd/lib/modal';
import PhoneInput from 'react-phone-input-2';
import { updateProfile } from '../../../../../../API';
import { config } from '../../../../../../config';

import './ChangePhoneModal.less';

const { REACT_APP_BUILD_ENV } = config;

export const ChangePhoneModal = (props) => {
  const { onCancel, onSubmit, theme } = props;
  const [newPhone, setNewPhone] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const currentUser = JSON.parse(localStorage.getItem('current_user'));
  const { email, first_name: firstName, last_name: lastName, phone_number: phoneNumber } = currentUser;

  const submitPhoneChange = async () => {
    const response = await updateProfile(REACT_APP_BUILD_ENV, email, firstName, lastName, `+${newPhone}`);

    if (response === 200) {
      setErrorMessage('');
      onSubmit();
    } else {
      setErrorMessage(`${response}`);
    }
  };

  return (
    <Modal
      className={`alerts-preferences-change-phone-modal alerts-preferences-change-phone-modal-${theme}`}
      centered
      open
      keyboard
      title="Change Phone Number"
      footer={null}
      onCancel={onCancel}
    >
      <div className="alerts-preferences-change-phone-modal__current-phone-container">
        <span className="alerts-preferences-change-phone-modal__container-title">Current phone number:</span>
        <strong className="alerts-preferences-change-phone-modal__current-phone">{phoneNumber}</strong>
      </div>
      <div className="alerts-preferences-change-phone-modal__input-container">
        <span className="alerts-preferences-change-phone-modal__container-title">New Phone Number:</span>
        <PhoneInput
          country="ca"
          preferredCountries={['ca', 'us']}
          value={newPhone}
          onChange={(e) => setNewPhone(e)}
          enableSearch
          disableSearchIcon
          buttonClass="alerts-preferences-change-phone-modal__phone-button"
          dropdownClass="alerts-preferences-change-phone-modal__phone-dropdown"
          inputClass="alerts-preferences-change-phone-modal__input"
        />
      </div>
      <Button size="large" className="alerts-preferences-change-phone-modal__button" onClick={submitPhoneChange}>
        <span className="alerts-preferences-change-phone-modal__button-text">Apply Change</span>
      </Button>
      {errorMessage && <div className="alerts-preferences-change-phone-modal__error">{errorMessage}</div>}
    </Modal>
  );
};
